import { useSelector } from "react-redux";
import { IConfigureMetric, IGpsMetricMappingValidation, ISampleDataPointDataType, MappingMode } from "./consts"
import Metric from "./Metrics"
import { useState } from "react";
import { Button, Row, Typography } from "antd";

const { Text } = Typography

export const ConfigureMetrics = ({
    configureMetricsData,
    filteredConfigureMetricsData,
    globalIndexesForActiveTab,
    activeUnitKey,
    setConfigureMetricsData,
    metricMappingSampleDatapoints,
    metricIdsToDelete,
    setMetricIdsToDelete,
    validationData,
    page,
    originalConfigureMetricsData,
}: IConfigureMetrics) => {
    let {
        misc: {
            conversion_options: metricsMappingConversion,
            built_in_function_options: metricsBuiltinFormula
        },
        metrics,
        allGpsMetrics
    } = useSelector(({ team }) => team);

    metricsMappingConversion = metricsMappingConversion?.sort((a: any, b: any) => a.label.localeCompare(b.label))
        .map((e: any) => {
            return {
                "label": e?.label,
                "value": e?.key,
                "key": e?.key
            }
        })

    metricsBuiltinFormula = metricsBuiltinFormula?.sort((a: any, b: any) => a.label.localeCompare(b.label))
        .map((e: any) => {
            return {
                "label": e?.label,
                "value": e?.key,
                "key": e?.key
            }
        })

    allGpsMetrics = allGpsMetrics?.sort((a: any, b: any) => a.name.localeCompare(b.name))
        .map((e: any) => {
            return {
                "label": e?.name,
                "value": e?.metric_id,
                "key": e?.metric_id
            }
        })

    metrics = metrics?.sort((a: any, b: any) => a.name.localeCompare(b.name))
        .map((e: any) => {
            return {
                "label": e?.name,
                "value": e?.metric_id
            }
        })

    const emptyConfigureMetric: IConfigureMetric = {
        "metric": undefined,
        "extractionApproach": MappingMode.SLUG,
        "extractionText": undefined,
        "conversion": undefined,
        "units": undefined
    }
    const [newConfiureMetric, setNewConfigureMetric] = useState<IConfigureMetric>(emptyConfigureMetric)

    const updateFieldData = (
        updates: Partial<IConfigureMetric>,
        localIdx: number
    ) => {
        const globalIdx = globalIndexesForActiveTab[localIdx]
        const localData = [...configureMetricsData];
        localData[globalIdx] = { ...localData[globalIdx], ...updates };
        setConfigureMetricsData(localData);
    };

    const addConfigureMetric = () => {
        const localData = [...configureMetricsData]
        localData.unshift({ ...newConfiureMetric, source_gps_unit: activeUnitKey })
        setConfigureMetricsData(localData)
        setNewConfigureMetric(emptyConfigureMetric)
    }

    const deleteConfigureMetric = (localIdx: number) => {
        const globalIdx = globalIndexesForActiveTab[localIdx]
        if (configureMetricsData[globalIdx].metric !== undefined && originalConfigureMetricsData.find((e) => e.metric === configureMetricsData[globalIdx].metric)) {
            setMetricIdsToDelete(metricIdsToDelete.concat(Number(configureMetricsData[globalIdx].metric)))
        }

        const localData = [...configureMetricsData]
        localData.splice(globalIdx, 1)
        setConfigureMetricsData(localData)
    }

    const metricMappingSampleDatapointsFlattend =
        (metricMappingSampleDatapoints?.[0] || [])
            .filter(e => typeof e.value !== 'object')
            .map(e => ({
                value: e.field,
                label: e.field
            }));

    return (
        <>
            <Row>
                <Button onClick={addConfigureMetric} style={{ marginBottom: '10px' }}>
                    {filteredConfigureMetricsData.length === 0
                        ?
                        "Configure a metric"
                        :
                        "Add more"
                    }
                </Button>
            </Row>

            {filteredConfigureMetricsData.map((data, localIdx) => {
                return (
                    <div key={`configure-metrics-${globalIndexesForActiveTab[localIdx]}`}>
                        {(validationData && validationData.validation_results[localIdx]?.error) &&
                            <Text type="danger">{validationData.validation_results[localIdx].error}</Text>
                        }
                        <Metric
                            key={globalIndexesForActiveTab[localIdx]}
                            status="old"
                            data={data}
                            metricsData={allGpsMetrics}
                            idx={localIdx}
                            updateFieldData={updateFieldData}
                            deleteConfigureMetric={deleteConfigureMetric}
                            metricMappingSampleDatapoints={metricMappingSampleDatapointsFlattend}
                            sampleData={(metricMappingSampleDatapoints?.[page] || [])
                                .filter(e => typeof e.value !== 'object')}
                            metricsBuiltinFormula={metricsBuiltinFormula}
                            metricsMappingConversion={metricsMappingConversion}
                            open={localIdx == 0}
                        />
                    </div>
                )
            })}
        </>
    )
}

interface IConfigureMetrics {
    originalConfigureMetricsData: IConfigureMetric[],
    configureMetricsData: IConfigureMetric[],
    filteredConfigureMetricsData: IConfigureMetric[],
    globalIndexesForActiveTab: number[],
    activeUnitKey: string,
    setConfigureMetricsData: React.Dispatch<React.SetStateAction<IConfigureMetric[]>>,
    metricMappingSampleDatapoints: ISampleDataPointDataType[][],
    metricIdsToDelete: number[],
    setMetricIdsToDelete: React.Dispatch<React.SetStateAction<number[]>>,
    validationData: IGpsMetricMappingValidation | undefined,
    page: number
}

export default ConfigureMetrics
